// extracted by mini-css-extract-plugin
export var currencyInput = "_ot-1";
export var currencySymbol = "_ot-0";